module.exports = __webpack_public_path__ + "img/purchase.f02a2f75.png";